import script from "./LoadingRing.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingRing.vue?vue&type=script&setup=true&lang=ts"

import "./LoadingRing.vue?vue&type=style&index=0&id=20bf2d31&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20bf2d31"]])

export default __exports__